import type { FunctionComponent } from 'react'

import { BrowserRouter } from 'react-router-dom'

import type { WhiteLabelSubdomainInfo } from '../../api/budgetApiClient'

import { WhiteLabelSubdomainType } from '../../api/budgetApiClient'
import { BudgetHelperRoutes } from '../BudgetHelper'
import { ClientDomainLandingPageContent } from './ClientDomain'

export const GenericLandingPageContent: FunctionComponent<{
	subdomainInfo: WhiteLabelSubdomainInfo
	children?: never
	consumerInputsStepIndex?: number
}> = ({ subdomainInfo, consumerInputsStepIndex }) => {
	return subdomainInfo.type === WhiteLabelSubdomainType.BudgetHelper ? (
		<BrowserRouter>
			<BudgetHelperRoutes
				subdomainInfo={subdomainInfo}
				consumerInputsStepIndex={consumerInputsStepIndex}
			/>
		</BrowserRouter>
	) : (
		<ClientDomainLandingPageContent subdomainInfo={subdomainInfo} />
	)
}
